import { RequestError } from '@requests/common';
import { getSecrets, IntegrationSecret } from '@requests/secrets';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';

const SECRETS_STALE_TIME = 1000 * 60 * 3; // 3 minutes

export const useSecrets = () => {
  const { service_id } = useParams<{ service_id: string }>();

  const {
    data: secrets = [],
    isLoading,
    isFetching,
    error,
    refetch,
  } = useQuery<IntegrationSecret[], RequestError, IntegrationSecret[], [string, { serviceId: string | undefined }]>({
    queryKey: ['secrets', { serviceId: service_id }],
    queryFn: getSecrets,
    staleTime: SECRETS_STALE_TIME,
    refetchOnReconnect: false,
    retry: false,
    enabled: Boolean(service_id),
  });

  return {
    secrets: secrets,
    loading: isLoading,
    fetching: isFetching,
    error,
    refetch,
  };
};
